var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-upload"},[_c('el-upload',{attrs:{"action":_vm.baseURL + '/upload',"headers":{token: _vm.token},"accept":_vm.accept,"on-remove":_vm.deleteFile,"on-change":_vm.uploadFile,"file-list":_vm.fileList}},[_c('el-button',{attrs:{"size":"small","type":"primary","icon":"el-icon-upload"}},[_vm._v("点击上传")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad4872ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fileUpload.vue
// module id = null
// module chunks = 